import { Form, Radio } from "antd";

const { Item } = Form;

const RadioGroupItem = ({
  size,
  label,
  options,
  onChange,
  required,
  labelCol,
  fieldName,
  wrapperCol,
  initialValue,
  formItemLayout,
}) => (
  <Item
    label={label}
    name={fieldName}
    required={required}
    initialValue={initialValue}
    labelCol={
      labelCol ? { span: labelCol } : formItemLayout && formItemLayout.labelCol
    }
    wrapperCol={
      wrapperCol
        ? { span: wrapperCol }
        : formItemLayout && formItemLayout.wrapperCol
    }
  >
    <Radio.Group size={size || "medium"} onChange={onChange}>
      {options &&
        options !== "e" &&
        options.map((o, i) => (
          <Radio.Button key={i} value={o.id}>
            {o.name}
          </Radio.Button>
        ))}
    </Radio.Group>
  </Item>
);

export default RadioGroupItem;
